module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/~/axios/index.js
// module id = 1358
// module chunks = 0